import { BaseProviderInstanceResourceModel } from './base-provider-instance-resource-model';

export class ProviderInstanceResourceSummaryModel extends BaseProviderInstanceResourceModel {
  id: string;
  name: string;
  isActive: boolean;
  userId: string|null;
  isPremium: boolean;
}
